import type {
  EnvName,
  UserInfo,
  WidgetPublicState,
  ResolvedHosts,
} from "@/types";
import type { WidgetConfig } from "@/config";
import { buildEnvironment, buildLoginUrl, buildClientLogoutUrl } from "@/core";

type BuiltEnvironment = ReturnType<typeof buildEnvironment>;

export const buildFallbackState = (): WidgetPublicState => ({
  ready: true,
  loggedIn: false,
  env: "prod",
  clientId: "",
  user: null,
  // Script `data-avatarUrl` / `data-avatarWidth` (logged-out override) temporarily disabled:
  avatarUrl: undefined,
  avatarWidth: undefined,
  language: "el",
  urls: { loginUrl: "", logouturl: "", profileUrl: "", authHost: "" },
});

export const computePublicState = (
  cfg: WidgetConfig,
  hosts: ResolvedHosts,
  environment: BuiltEnvironment,
  user: UserInfo | null,
  env: EnvName,
): WidgetPublicState => {
  const loggedIn = !!user;

  const loginUrl = buildLoginUrl(environment, cfg);
  const logouturl = buildClientLogoutUrl(hosts.authHost, cfg);
  const profileUrl = environment.settingDefaultUrl;

  return {
    ready: true,
    loggedIn,
    env,
    clientId: cfg.clientId,
    user: user ?? null,
    // Logged-out avatar override (`data-avatarUrl` / `data-avatarWidth`) temporarily disabled:
    avatarUrl: undefined,
    avatarWidth: undefined,
    language: cfg.language ?? "el",
    urls: { loginUrl, logouturl, profileUrl, authHost: hosts.authHost },
  };
};
